import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import ItecTable from './itectable/itectable';
import SearchBox from '../../../components/table/SearchBox';
import { CommonConfig } from '../../../config/common-config';
import './itecopenstyles.css';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    }
}));

const ItecOpenServiceAM = (props) => {
    // const classes = useStyles();
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setitecOpenService] = useState([]);
    // const [particularRow ,setParticularRow] = useState([]);
    // const vertical = 'top';
    // const horizontal = 'center';
    //console.log("dbname", dbname);

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const headcells = [
        { id: 'serviceId', label: 'Service ID' },
        { id: 'clientId', label: 'Client ID' },
        { id: 'clientName', label: 'Name' },
        { id: 'clientType', label: 'Client type' },
        { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'dateCreated', label: 'Date at this stage' },
        { id: 'statusId', label: 'Current Status', isConcat: 'true', concatElem: ['statusText'] },
    ];

    // const history = useHistory();

    useEffect(
        (data) => {
            const userData = JSON.parse(sessionStorage.getItem('user'));
            const imc = JSON.parse(userData.result.config.data).tennantName;
            
            if((bearerToken != undefined) && (bearerToken != null)){
                axios
                    .get(`${CommonConfig.dev.baseUrl}/api/auth/createservice-employee/${imc}?size=500`, {
                        headers: {
                        Authorization: bearerToken,
                        },
                    })
                    .then((response) => {
                        let allData = response.data.content;
                        const dataRow = allData.map((row) => {
                            return row;
                        });
                        //console.log("dataRow", dataRow);
                        setitecOpenService(dataRow);
                    })
                    .catch((error) => {
                        //console.log(error);
                    });
                }
            }, [bearerToken]
        );


    // search Query
    const handleSearchQuery = (searchData) => {
        setSearchQuery(searchData);
    };

    // Search through nested objects
    const filteredRow = searchQuery
        ? rows.filter((searchRow) => {
            const query = searchQuery.toLowerCase().trim();
            return headcells
                .map((col) => col)
                .some((key) => {

                    if (key.isConcat && searchRow[key.id]) {
                        const subdata = searchRow[key.id];
                        const mergedData = key.concatElem.map((concatdata) => {
                            return concatdata.split('.').reduce((acc, item) => {
                                if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                    if (typeof acc[item] !== 'object') {
                                        return acc[item].toString().toLowerCase().includes(query);
                                    }
                                    return acc[item];
                                }
                                return false;
                            }, subdata);
                        });
                        return mergedData[0];
                    }
                    return searchRow[key.id].toString().toLowerCase().includes(query);
                });
        })
    : rows;

    return (
        <Card className="custom-table">
            <CardContent className="card-title-display">
            <Grid item xs={12} sm={6}>
                <Typography className="card-title"> Tasks </Typography>
                </Grid>
                <Grid item xs={12} sm={6} className="card-search">
                <div className="search-field">
                    <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} placeholder="Search..." />
                </div>
                {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '700' }}>No records found to display!</span>}
                </Grid>
            </CardContent>
            <CardContent className="card-table-display">
                <ItecTable
                  headcells={headcells}
                  itecServiceRows={filteredRow}
                  action
                  pageName="itecopen"
                  service="open" />
            </CardContent>
        </Card>
                    
    );
};

export default ItecOpenServiceAM;
